import { Box, Typography } from "@mui/material";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ContainerWrapper from "../../components/ContainerWrapper/ContainerWrapper";
import ActionButton from "../../components/Button/ActionButton";
import HelpContent from "../../components/payments/HelpContent/HelpContent";
import { PAYMENTS_HELP_CONTENT } from "../../constants";
import { configurationPath } from "../../utils/paymentsRoutes";
import { pageTitleSx } from "../../utils/pageStyles";

/**
 * Shown right after a configuration is created: explains what is still missing
 * (tax authority credentials and KYC documents) before it can be used to
 * charge, then leads to the configuration hub where both are done.
 */
export default function PaymentConfigurationNextSteps() {
  const { t } = useTranslation();
  const history = useHistory();
  const { configId } = useParams<{ configId: string }>();

  return (
    <ContainerWrapper>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        <Typography sx={pageTitleSx}>{t("paymentNextSteps.title")}</Typography>
        <HelpContent linkName={PAYMENTS_HELP_CONTENT.NEXT_STEPS} />
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <ActionButton
            label={t("paymentNextSteps.continue")}
            onClick={() => history.push(configurationPath(configId))}
          />
        </Box>
      </Box>
    </ContainerWrapper>
  );
}
